import { useLocation, Redirect } from 'quartz-routing/react-router';
import { EmbeddedContentPage } from '../components/EmbeddedContentPage';
import { Paths } from '../constants/Paths';
import { jsx as _jsx } from "react/jsx-runtime";
export function InvoiceDetailsPage() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const invoiceUrl = params.get('url');
  const invoiceNumber = params.get('invoiceNumber');
  if (!invoiceUrl) {
    return /*#__PURE__*/_jsx(Redirect, {
      to: Paths.INVOICES
    });
  }
  return /*#__PURE__*/_jsx(EmbeddedContentPage, {
    src: invoiceUrl,
    title: "Invoice",
    breadcrumbs: [{
      label: 'invoiceDetails.breadcrumb.invoices',
      href: Paths.INVOICES
    }, {
      label: invoiceNumber ? 'invoiceDetails.breadcrumb.invoiceNumber' : 'invoiceDetails.breadcrumb.invoiceDetails',
      options: invoiceNumber ? {
        invoiceNumber
      } : undefined
    }],
    subscreen: "invoice-details"
  });
}